import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard, EducationalBlock } from './shared';

const CNPJValidator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [formattedCnpj, setFormattedCnpj] = useState('');
  const [isValid, setIsValid] = useState<boolean | null>(null);

  const validateCNPJ = (cnpj: string) => {
    const clean = cnpj.replace(/[^\d]/g, '');
    if (clean.length !== 14) return { valid: false };
    const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let sum = 0;
    for (let i = 0; i < 12; i++) sum += parseInt(clean.charAt(i)) * weights1[i];
    let v1 = sum % 11 < 2 ? 0 : 11 - (sum % 11);

    sum = 0;
    for (let i = 0; i < 13; i++) sum += parseInt(clean.charAt(i)) * weights2[i];
    let v2 = sum % 11 < 2 ? 0 : 11 - (sum % 11);

    return { valid: v1 === parseInt(clean.charAt(12)) && v2 === parseInt(clean.charAt(13)) };
  };

  const formatCNPJ = (cnpj: string) => {
    const clean = cnpj.replace(/[^\d]/g, '');
    if (clean.length <= 2) return clean;
    if (clean.length <= 5) return `${clean.slice(0, 2)}.${clean.slice(2)}`;
    if (clean.length <= 8) return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5)}`;
    if (clean.length <= 12) return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}`;
    return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12, 14)}`;
  };

  const handleValidate = () => {
    const clean = formattedCnpj.replace(/[^\d]/g, '');
    const res = validateCNPJ(clean);
    setIsValid(res.valid);
    onResultChange([{ label: 'CNPJ', value: formattedCnpj }, { label: 'Status', value: res.valid ? 'Válido' : 'Inválido' }]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="CNPJ" placeholder="00.000.000/0000-00" value={formattedCnpj} onChange={v => setFormattedCnpj(formatCNPJ(v))} required />
          <div className="flex items-center pt-6">
            <button onClick={handleValidate} className="px-8 py-3 bg-accent-gradient text-white rounded-xl font-bold hover:scale-105 transition-all flex items-center gap-2">
              <Icon name="check-circle" className="w-5 h-5" /> Validar
            </button>
          </div>
        </div>
        {isValid !== null && <ResultCard title="Status" value={isValid ? 'Válido' : 'Inválido'} color={isValid ? 'green' : 'red'} />}
      </div>
    </div>
  );
};

export default CNPJValidator;
